module.exports = __webpack_public_path__ + "static/media/wizardFalling.ef8d8d56.gif";